import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { HighlightsService } from '../../../services/selections/highlights';
import { SelectionsService } from '../../../services/selections/selections';
import { NoteDialogComponent } from '../note-dialog/note-dialog';
import { NoteShareDialogComponent } from '../note-share-dialog/note-share-dialog';
import { SharedNoteDialogComponent } from '../shared-note-dialog/shared-note-dialog';

@Component({
  selector: 'nr-note-dialog-manager',
  imports: [NoteDialogComponent, NoteShareDialogComponent, SharedNoteDialogComponent],
  templateUrl: './note-dialog-manager.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NoteDialogManagerComponent {
  private readonly highlightsService = inject(HighlightsService);
  private readonly selectionsService = inject(SelectionsService);

  readonly note = this.highlightsService.noteToEdit;
  readonly shareNote = this.highlightsService.shareNote;

  handleClose(): void {
    if (this.shareNote()) return;

    const note = this.note();
    if (note && this.highlightsService.noteIsDraft()) {
      this.selectionsService.removeSelection(note.id);
      this.highlightsService.removeHighlight(note);
    }
    this.highlightsService.noteIsDraft.set(false);
    this.highlightsService.noteToEdit.set(undefined);
  }

  handleShareClose(): void {
    this.highlightsService.noteToEdit.set(undefined);
    this.highlightsService.shareNote.set(false);
  }
}
